import React, { useEffect } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Grid, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import { useEstoquesMedicamentoState } from "../context/estoques-medicamento-context";
import { useEstoquesMedicamentoController } from "../context/estoques-medicamento-controller";
import { TextInputWithCounter } from "../../../components/text-input-with-counter";

export const EstoqueMedicamentoForm = () => {
    const { dataRequest, orgaosList } = useEstoquesMedicamentoState();
    const { handleOnChangeForm, loadLookups } = useEstoquesMedicamentoController();

    useEffect(() => {
        (async () => {
            await loadLookups();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid item lg={12} sm={12} xl={12}>
                        <InputLabel>Medicamento *</InputLabel>
                        <TextInputWithCounter
                            size="small"
                            maxLength={150}
                            error={!dataRequest?.nomeMedicamento}
                            value={dataRequest?.nomeMedicamento || ''}
                            onChange={(e) => handleOnChangeForm('nomeMedicamento', e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={6} sm={6} xl={6}>
                        <InputLabel>Farmácia/Unidade (Órgão)</InputLabel>
                        <Select
                            size="small"
                            value={dataRequest?.idOrgao ?? ''}
                            onChange={(e) => handleOnChangeForm('idOrgao', e.target.value || null)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Não especificado</em></MenuItem>
                            {orgaosList?.slice().sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')).map((o) => <MenuItem value={o.id} key={o.id}>{o.name}</MenuItem>)}
                        </Select>
                    </Grid>

                    <Grid item lg={3} sm={3} xl={3}>
                        <InputLabel>Quantidade em Estoque *</InputLabel>
                        <OutlinedInput
                            size="small"
                            type="number"
                            error={dataRequest?.quantidadeEstoque === null || dataRequest?.quantidadeEstoque === undefined}
                            value={dataRequest?.quantidadeEstoque ?? ''}
                            onChange={(e) => handleOnChangeForm('quantidadeEstoque', e.target.value === '' ? null : Number(e.target.value))}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={3} sm={3} xl={3}>
                        <InputLabel>Data de Atualização *</InputLabel>
                        <DesktopDatePicker
                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small", error: !dataRequest?.dtaAtualizacao } }}
                            value={dataRequest?.dtaAtualizacao ? dayjs(dataRequest.dtaAtualizacao) : null}
                            onChange={(value: Dayjs | null) => handleOnChangeForm('dtaAtualizacao', value?.toISOString())}
                        />
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    );
};
